const initialState = { data: [], loading: true };

export const GetAllCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_category":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
